module.exports = __webpack_public_path__ + "img/xbhp.ed18447f.jpg";